import { parseUnsafeString, getValidValue, pluck, pluckNumber, preDefStr, convertColor, BLANK } from '@fusioncharts/core/src/lib';
import SankeyNode from '../dataset/sankey/sankey-node';

const NONE = 'none',
  validPosition = ['start', 'inside', 'end'];

export default function (dataset) {
  let dsConfig = dataset.config,
    {
      nodes,
      enableDrag,
      style
    } = dsConfig,
    nodeComponent,
    labelCss,
    nodeCss,
    nodeFocusCss,
    nodeFocusOutCss,
    rawCosmetics,
    rawLabelCosmetics,
    labelBgColor,
    labelBorderColor,
    labelPosition,
    cursor,
    chartAttr = dataset.getFromEnv('dataSource').chart,
    nodeLabelStyle = style.node.label,
    nodeLabelAlpha,
    inheritFromPlot = pluckNumber(chartAttr.inheritlabelcolorfromnode, 1),
    colorM = dataset.getFromEnv('color-manager'),
    numberFormatter = dataset.getFromEnv('number-formatter'),
    {
      dataLabelStyle,
      showLegend
    } = dataset.getFromEnv('chartConfig'),
    id;

  nodes.forEach((node, index) => {
    id = pluck(node.id, node.label);

    rawCosmetics = {
      fill: pluck(node.color, chartAttr.nodecolor, colorM.getPlotColor(index)),
      alpha: pluckNumber(node.alpha, chartAttr.nodealpha, 100),
      focusAlpha: pluckNumber(node.hoveralpha, chartAttr.nodehoveralpha, 100),
      focusOutAlpha: 40,
      stroke: NONE
    };

    nodeLabelAlpha = pluck(node.labelalpha, chartAttr.nodelabelalpha, chartAttr.labelalpha, inheritFromPlot ? rawCosmetics.alpha : 100);

    labelBgColor = pluck(node.labelbgcolor, chartAttr.nodelabelbgcolor, chartAttr.labelbgcolor);
    labelBgColor = labelBgColor
      ? convertColor(labelBgColor, nodeLabelAlpha)
      : BLANK;

    labelBorderColor = pluck(node.labelbordercolor, chartAttr.nodelabelbordercolor, chartAttr.labelbordercolor);
    labelBorderColor = labelBorderColor
      ? convertColor(labelBorderColor, nodeLabelAlpha)
      : BLANK;

    rawLabelCosmetics = Object.assign({}, dataLabelStyle, {
      labelFill: pluck(node.labelfontcolor, chartAttr.nodelabelfontcolor, chartAttr.labelfontcolor, chartAttr.basefontcolor, inheritFromPlot ? rawCosmetics.fill : '#5f5f5f'),
      labelAlpha: nodeLabelAlpha,
      focusAlpha: rawCosmetics.focusAlpha,
      focusOutAlpha: rawCosmetics.focusOutAlpha,
      border: labelBgColor ? nodeLabelStyle.borderThickness + 'px solid' : BLANK,
      borderColor: labelBorderColor,
      backgroundColor: labelBgColor
    });

    cursor = enableDrag ? 'move' : 'default';

    labelCss = {
      cursor,
      'text-bound': [
        labelBgColor, labelBorderColor,
        nodeLabelStyle.borderThickness, nodeLabelStyle.borderPadding,
        nodeLabelStyle.borderRadius, nodeLabelStyle.borderDash
      ],
      fill: convertColor(rawLabelCosmetics.labelFill, rawLabelCosmetics.labelAlpha)
    };
    labelPosition = pluck(node.labelposition, chartAttr.nodelabelposition, preDefStr.POSITION_END).toLowerCase();
    if (validPosition.indexOf(labelPosition) < 0) {
      labelPosition = preDefStr.POSITION_END;
    }

    nodeCss = {
      fill: convertColor(rawCosmetics.fill, rawCosmetics.alpha),
      cursor,
      stroke: rawCosmetics.stroke
    };

    nodeFocusCss = {
      fill: convertColor(rawCosmetics.fill, rawCosmetics.focusAlpha)
    };

    nodeFocusOutCss = {
      fill: convertColor(rawCosmetics.fill, rawCosmetics.focusOutAlpha)
    };

    nodeComponent = dataset.attachChild(SankeyNode, 'nodes', id);
    nodeComponent.setData({
      id,
      index,
      mode: 'normal',
      label: pluck(node.label, node.id),
      value: numberFormatter.dataLabels(node.props.value),
      labelPadding: numberFormatter.getCleanValue(pluck(node.labelpadding, chartAttr.nodelabelpadding, 5)),
      visible: pluckNumber(node.visible, chartAttr.shownodes, 1),
      showLabel: pluckNumber(node.showlabel, chartAttr.shownodelabels, 1),
      showValue: pluckNumber(node.showvalue, chartAttr.shownodevalues, 0),
      rotateLabel: pluckNumber(node.rotatelabel, chartAttr.rotatenodelabels, 0),
      labelPosition,
      valuePosition: pluck(node.labelposition, chartAttr.nodelabelposition, preDefStr.POSITION_MIDDLE),
      plotToolText: getValidValue(parseUnsafeString(pluck(node.tooltext,
        chartAttr.plottooltext))),
      toolText: getValidValue(parseUnsafeString(pluck(node.tooltext,
        node.tooltext))),
      nodeValue: pluckNumber(node.nodevalue, chartAttr.nodevalue, 0),
      nodeDataValue: numberFormatter.dataLabels(node.nodedatavalue),
      // linkPadding: pluckNumber(node.linkpadding, chartAttr.nodelinkpadding, 0),
      textOutline: pluckNumber(node.textoutline, chartAttr.textoutline, 0),
      rawCosmetics,
      rawLabelCosmetics,
      props: node.props,
      eventArgs: {
        color: rawCosmetics.fill,
        alpha: rawCosmetics.alpha,
        labelFill: rawLabelCosmetics.labelFill,
        labelAlpha: rawLabelCosmetics.labelAlpha,
        value: node.props.value,
        label: node.label,
        sourceLinks: node.props.sourceLinks.map(link => link.to),
        targetLinks: node.props.targetLinks.map(link => link.from)
      },
      style: {
        node: {
          normal: nodeCss,
          focus: nodeFocusCss,
          focusOut: nodeFocusOutCss
        },
        label: {
          normal: labelCss,
          focus: Object.assign({}, labelCss, {
            fill: convertColor(rawLabelCosmetics.labelFill, rawLabelCosmetics.focusAlpha)
          }),
          focusOut: Object.assign({}, labelCss, {
            fill: convertColor(rawLabelCosmetics.labelFill, rawLabelCosmetics.focusOutAlpha)
          })
        }
        // value: {
        //   normal: valueCss,
        //   focus: valueCss,
        //   focusOut: Object.assign({}, valueCss, {
        //     fill: convertColor(rawLabelCosmetics.valueFill, rawLabelCosmetics.focusOutAlpha)
        //   })
        // }
      }
    });
  });

  showLegend && dataset._addLegend();
};
